import { HeadingMedium } from "@mezo-org/mezo-clay"
import { useMatches, useRouteContext } from "@tanstack/react-router"

import { NAVIGATION_ITEMS } from "#/shared/constants"

export default function DashboardHeaderTitle() {
  const [matchedRouteWithCustomHeader] = useMatches({
    select: (matches) =>
      [...matches]
        .reverse()
        .filter((_) => !!("customHeaderComponent" in _.context)),
  })

  const { customHeaderComponent: CustomHeaderComponent } = useRouteContext({
    from: matchedRouteWithCustomHeader?.routeId,
  })

  if (CustomHeaderComponent) {
    return <CustomHeaderComponent />
  }

  const navigationItem = NAVIGATION_ITEMS.find(
    (item) => item.route === window.location.pathname,
  )

  if (!navigationItem) return null

  return <HeadingMedium>{navigationItem?.pageTitle}</HeadingMedium>
}
